import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {FilterData, FilterService} from '@app/assetfilter/filter.service';
import {FiltersSheetComponent} from '@app/assetfilter/filters-sheet/filters-sheet.component';
import {StateService} from '@app/state/state.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
    selector: 'frog-filters-sheet-button',
    templateUrl: './filters-sheet-button.component.html',
    styleUrls: ['./filters-sheet-button.component.scss'],
    imports: [MatIconButton, MatIcon, AsyncPipe],
})
export class FiltersSheetButtonComponent implements OnInit {
    public filterData$: Observable<FilterData>;

    constructor(
        private stateService: StateService,
        private filterService: FilterService,
        private matBottomSheet: MatBottomSheet,
    ) {}

    ngOnInit(): void {
        this.filterData$ = this.stateService.state.pipe(map((state) => state.filterData));
    }

    openSheet(): void {
        this.matBottomSheet.open(FiltersSheetComponent);
    }

    clear(): void {
        this.filterService.clear();
    }
}
